import React from 'react'
import { TasksList } from './list/page'

export const GoldenMay2025TasksPage = () => {
  return <TasksList />
}
